import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { useAppBarHeight } from 'hooks';
import styled from '@emotion/styled';
import PreviewCotainer from 'components/PreviewContainer';
import { FormPreviewProps } from './types';

const Container = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  // borderRadius: '5px',
  // margin: '10px',
  minHeight: 'calc(100vh - 56px)',
  maxHeight: 'calc(100vh - 56px)'
}));

const FormPreviewContainer = (props: FormPreviewProps) => {
  const appbarHeight = useAppBarHeight();
  return (
    <Container>
      <Stack
        direction={{ sm: 'column-reverse', md: 'row' }}
        justifyContent="center"
        spacing={4}
        divider={<Divider orientation="vertical" flexItem />}
        p={2}
        sx={{ maxWidth: '1260px', margin: '0 auto', height: 'calc(100vh - 56px)' }}
      >
        <Box width="100%" maxWidth="600px">
          {/* <Typography variant="h2" pb={2}>
            Add Details
          </Typography> */}
          {props.children}
        </Box>
        <Box width="100%">
          <Typography variant="h2" pb={2}>
            Preview
          </Typography>
          <PreviewCotainer
            conversionType={props.conversionType}
            description={props.description}
            icon={props.icon}
            iconName={props.iconName}
            title={props.title}
            type={props.type}
            tags={props.tags}
            redirectLink={props.redirectLink}
            showAssetFields={props.showAssetFields}
            video={props.video}
            property={props.property}
            category={props.category}
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default FormPreviewContainer;
